<script lang="ts">import 'yinzcam-cards';
import CardBase from '../../../common/CardBase.svelte';
import '../../../common/CardsDataSourceRegistration';
import 'svelte/store';
import 'framework7-svelte';
export let element;
export let sources;
const onBack = (e) => { };
</script>

<CardBase {element}>
  <div class="forgot-title">
    <h1>Forgot Password</h1>
    <button class="button" type="button" on:click={onBack}>
      <i class="f7-icons">chevron_left</i>
    </button>
  </div>
</CardBase>

<style lang="scss">*,
*::before,
*::after {
  box-sizing: border-box; }

.forgot-title {
  width: 100%;
  position: relative;
  padding: 15px 0 0 0; }
  .forgot-title h1 {
    width: 100%;
    text-align: center;
    text-transform: uppercase;
    font-size: 17px;
    font-weight: bold;
    letter-spacing: -0.22px;
    color: #ffffff;
    margin: 0; }
  .forgot-title .button {
    min-width: unset;
    min-height: unset;
    width: unset;
    height: unset;
    padding: 5px 10px;
    position: absolute;
    left: 0px;
    bottom: 0px; }
    .forgot-title .button .f7-icons {
      font-size: 24px;
      color: black;
      line-height: 1;
      display: block; }</style>
